<!--
 * @Author: your name
 * @Date: 2020-12-23 18:15:59
 * @LastEditTime: 2021-01-05 11:42:43
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Description: In User Settings Edit
 * @FilePath: \hsylc2021\src\components\Card\card.vue
-->
<template>
  <div class="component-card">
    <slot></slot>
  </div>
</template>
<script>
/**
 * ？？？
 * @module Card
 */
export default {
  name: '',
  props: {},
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" src="./card.less" scoped></style>
